webpackJsonp([63538265317374],{

/***/ "./nest-instigator.jpeg":
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/nest-instigator.0a512c46.jpeg";

/***/ }),

/***/ "./src/components/Pipeline.js":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  max-width: 700px;\n  margin: 0 auto;\n"], ["\n  width: 100%;\n  max-width: 700px;\n  margin: 0 auto;\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  border-collapse: collapse;\n  table-layout: fixed;\n"], ["\n  width: 100%;\n  border-collapse: collapse;\n  table-layout: fixed;\n"]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["width: 160px;\n  ", ";\n"], ["width: 160px;\n  ", ";\n"]),
	    _templateObject4 = _taggedTemplateLiteralLoose(["width: 100px;"], ["width: 100px;"]),
	    _templateObject5 = _taggedTemplateLiteralLoose([""], [""]),
	    _templateObject6 = _taggedTemplateLiteralLoose(["\n  font-size: 1.05rem;\n  font-weight: 600;\n  color: #6b7280;\n  text-align: left;\n  padding: 0.85rem 0.65rem;\n  border-bottom: 2px solid #e8eaed;\n  border-left: 1px solid #e8eaed;\n  vertical-align: bottom;\n\n  &:first-child {\n    border-left: none;\n  }\n\n  ", ";\n"], ["\n  font-size: 1.05rem;\n  font-weight: 600;\n  color: #6b7280;\n  text-align: left;\n  padding: 0.85rem 0.65rem;\n  border-bottom: 2px solid #e8eaed;\n  border-left: 1px solid #e8eaed;\n  vertical-align: bottom;\n\n  &:first-child {\n    border-left: none;\n  }\n\n  ", ";\n"]),
	    _templateObject7 = _taggedTemplateLiteralLoose(["\n    font-size: 0.94rem;\n    padding: 0.6rem;\n  "], ["\n    font-size: 0.94rem;\n    padding: 0.6rem;\n  "]),
	    _templateObject8 = _taggedTemplateLiteralLoose(["\n  padding: 0.85rem 0.65rem;\n  border-bottom: 1px solid #eff0f1;\n  border-left: 1px solid #e8eaed;\n  vertical-align: middle;\n  height: 76px;\n\n  &:first-child {\n    border-left: none;\n  }\n\n  ", ";\n"], ["\n  padding: 0.85rem 0.65rem;\n  border-bottom: 1px solid #eff0f1;\n  border-left: 1px solid #e8eaed;\n  vertical-align: middle;\n  height: 76px;\n\n  &:first-child {\n    border-left: none;\n  }\n\n  ", ";\n"]),
	    _templateObject9 = _taggedTemplateLiteralLoose(["\n    height: 75px;\n    padding: 0.6rem;\n  "], ["\n    height: 75px;\n    padding: 0.6rem;\n  "]),
	    _templateObject10 = _taggedTemplateLiteralLoose(["\n  font-size: 1.475rem;\n  font-weight: 700;\n  color: #005baa;\n  line-height: 1.3;\n\n  span {\n    display: block;\n    font-size: 1.125rem;\n    font-weight: 400;\n    color: #6b7280;\n    margin-top: 0.1rem;\n  }\n\n  ", ";\n"], ["\n  font-size: 1.475rem;\n  font-weight: 700;\n  color: #005baa;\n  line-height: 1.3;\n\n  span {\n    display: block;\n    font-size: 1.125rem;\n    font-weight: 400;\n    color: #6b7280;\n    margin-top: 0.1rem;\n  }\n\n  ", ";\n"]),
	    _templateObject11 = _taggedTemplateLiteralLoose(["\n    font-size: 1.25rem;\n    span { font-size: 1rem; }\n  "], ["\n    font-size: 1.25rem;\n    span { font-size: 1rem; }\n  "]),
	    _templateObject12 = _taggedTemplateLiteralLoose(["\n  padding: 0;\n  border-bottom: 1px solid #eff0f1;\n  border-left: 1px solid #e8eaed;\n  height: 76px;\n  position: relative;\n  overflow: visible;\n\n  ", ";\n"], ["\n  padding: 0;\n  border-bottom: 1px solid #eff0f1;\n  border-left: 1px solid #e8eaed;\n  height: 76px;\n  position: relative;\n  overflow: visible;\n\n  ", ";\n"]),
	    _templateObject13 = _taggedTemplateLiteralLoose(["\n    height: 75px;\n  "], ["\n    height: 75px;\n  "]),
	    _templateObject14 = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  left: 0;\n  height: 54px;\n  background: linear-gradient(90deg, #43bcba 0%, #1a6fb5 60%, #005baa 100%);\n  border-radius: 3px;\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  padding-right: 0.9rem;\n  z-index: 1;\n\n  ", ";\n"], ["\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  left: 0;\n  height: 54px;\n  background: linear-gradient(90deg, #43bcba 0%, #1a6fb5 60%, #005baa 100%);\n  border-radius: 3px;\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  padding-right: 0.9rem;\n  z-index: 1;\n\n  ", ";\n"]),
	    _templateObject15 = _taggedTemplateLiteralLoose(["\n    height: 30px;\n    padding-right: 0.5rem;\n  "], ["\n    height: 30px;\n    padding-right: 0.5rem;\n  "]),
	    _templateObject16 = _taggedTemplateLiteralLoose(["\n  font-size: 1.1rem;\n  font-weight: 600;\n  color: white;\n  white-space: nowrap;\n\n  ", ";\n"], ["\n  font-size: 1.1rem;\n  font-weight: 600;\n  color: white;\n  white-space: nowrap;\n\n  ", ";\n"]),
	    _templateObject17 = _taggedTemplateLiteralLoose(["\n    font-size: 0.69rem;\n  "], ["\n    font-size: 0.69rem;\n  "]);
	
	var _react = __webpack_require__("./node_modules/gatsby-plugin-react-next/node_modules/react/index.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__("./node_modules/styled-components/lib/index.js");
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var PHASES = ["Preclinical", "Phase 1", "Phase 2", "Phase 3"];
	
	var Container = _styledComponents2.default.div(_templateObject);
	
	var StyledTable = _styledComponents2.default.table(_templateObject2);
	
	var ColProduct = _styledComponents2.default.col(_templateObject3, function (props) {
	  return props.theme.media.mobile(_templateObject4);
	});
	var ColPhase = _styledComponents2.default.col(_templateObject5);
	
	var Th = _styledComponents2.default.th(_templateObject6, function (props) {
	  return props.theme.media.mobile(_templateObject7);
	});
	
	var Td = _styledComponents2.default.td(_templateObject8, function (props) {
	  return props.theme.media.mobile(_templateObject9);
	});
	
	var ProductNameText = _styledComponents2.default.div(_templateObject10, function (props) {
	  return props.theme.media.mobile(_templateObject11);
	});
	
	var PhaseTd = _styledComponents2.default.td(_templateObject12, function (props) {
	  return props.theme.media.mobile(_templateObject13);
	});
	
	var Bar = _styledComponents2.default.div(_templateObject14, function (props) {
	  return props.theme.media.mobile(_templateObject15);
	});
	
	var BarLabel = _styledComponents2.default.span(_templateObject16, function (props) {
	  return props.theme.media.mobile(_templateObject17);
	});
	
	var Pipeline = function Pipeline(_ref) {
	  var products = _ref.products;
	
	  var rows = [];
	  products.forEach(function (product) {
	    product.indications.forEach(function (indication, j) {
	      rows.push({ product: product, indication: indication, showName: j === 0, rowSpan: product.indications.length });
	    });
	  });
	
	  return _react2.default.createElement(
	    Container,
	    null,
	    _react2.default.createElement(
	      StyledTable,
	      null,
	      _react2.default.createElement(
	        "colgroup",
	        null,
	        _react2.default.createElement(ColProduct, null),
	        PHASES.map(function (p) {
	          return _react2.default.createElement(ColPhase, { key: p });
	        })
	      ),
	      _react2.default.createElement(
	        "thead",
	        null,
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            Th,
	            null,
	            "Candidate"
	          ),
	          PHASES.map(function (phase) {
	            return _react2.default.createElement(
	              Th,
	              { key: phase },
	              phase
	            );
	          })
	        )
	      ),
	      _react2.default.createElement(
	        "tbody",
	        null,
	        rows.map(function (row, i) {
	          return _react2.default.createElement(
	            "tr",
	            { key: i },
	            row.showName ? _react2.default.createElement(
	              Td,
	              { rowSpan: row.rowSpan },
	              _react2.default.createElement(
	                ProductNameText,
	                null,
	                row.product.name,
	                row.product.subtitle && _react2.default.createElement(
	                  "span",
	                  null,
	                  row.product.subtitle
	                )
	              )
	            ) : null,
	            PHASES.map(function (phase, pi) {
	              return _react2.default.createElement(
	                PhaseTd,
	                { key: phase },
	                pi === 0 && _react2.default.createElement(
	                  Bar,
	                  { style: { width: row.indication.progress / 25 * 100 + "%" } },
	                  _react2.default.createElement(
	                    BarLabel,
	                    null,
	                    row.indication.label
	                  )
	                )
	              );
	            })
	          );
	        })
	      )
	    )
	  );
	};
	
	Pipeline.defaultProps = {
	  products: [{
	    name: "NES/T",
	    subtitle: "hormonal gel",
	    indications: [{
	      disease: "Male Contraception",
	      progress: 73,
	      label: "Phase 2B Completed"
	    }]
	  }, {
	    name: "ADAM",
	    subtitle: "non-hormonal implant",
	    indications: [{
	      disease: "Male Contraception",
	      progress: 48,
	      label: "Phase 2 Ready"
	    }]
	  }]
	};
	
	exports.default = Pipeline;
	module.exports = exports["default"];

/***/ }),

/***/ "./node_modules/babel-loader/lib/index.js?{\"presets\":[\"/vercel/path0/node_modules/babel-preset-react-app/index.js\",[\"/vercel/path0/node_modules/babel-preset-env/lib/index.js\",{\"loose\":true,\"uglify\":true,\"modules\":\"commonjs\",\"targets\":{\"browsers\":[\"> 1%\",\"IE >= 9\",\"Safari >= 9\",\"last 2 versions\"]},\"exclude\":[\"transform-regenerator\",\"transform-es2015-typeof-symbol\"]}],\"/vercel/path0/node_modules/babel-preset-stage-0/lib/index.js\",\"/vercel/path0/node_modules/babel-preset-react/lib/index.js\",[\"/vercel/path0/node_modules/babel-preset-env/lib/index.js\",{\"loose\":true,\"uglify\":true,\"modules\":\"commonjs\",\"targets\":{\"browsers\":[\"> 1%\",\"IE >= 9\",\"Safari >= 9\",\"last 2 versions\"]},\"exclude\":[\"transform-regenerator\",\"transform-es2015-typeof-symbol\"]}],\"/vercel/path0/node_modules/babel-preset-stage-0/lib/index.js\",\"/vercel/path0/node_modules/babel-preset-react/lib/index.js\"],\"plugins\":[\"/vercel/path0/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",\"/vercel/path0/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",\"/vercel/path0/node_modules/react-hot-loader/babel.js\",\"/vercel/path0/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/vercel/path0/node_modules/babel-plugin-transform-object-assign/lib/index.js\",\"/vercel/path0/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/vercel/path0/node_modules/babel-plugin-transform-object-assign/lib/index.js\"],\"cacheDirectory\":true}!./src/pages/trials.js":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  flex: 5;\n  margin-left: 0rem;\n\n  ", ";\n"], ["\n  flex: 5;\n  margin-left: 0rem;\n\n  ", ";\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n    margin-left: 0rem;\n    padding-right: 3rem;\n  "], ["\n    margin-left: 0rem;\n    padding-right: 3rem;\n  "]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n  ", ";\n"], ["\n  ", ";\n"]),
	    _templateObject4 = _taggedTemplateLiteralLoose(["\n  flex: 5;\n  padding-left: 6rem;\n\n  ", ";\n"], ["\n  flex: 5;\n  padding-left: 6rem;\n\n  ", ";\n"]),
	    _templateObject5 = _taggedTemplateLiteralLoose(["\n    padding-left: 1rem;\n    padding-right: 1rem;\n  "], ["\n    padding-left: 1rem;\n    padding-right: 1rem;\n  "]);
	
	var _react = __webpack_require__("./node_modules/gatsby-plugin-react-next/node_modules/react/index.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__("./node_modules/styled-components/lib/index.js");
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactHelmet = __webpack_require__("./node_modules/react-helmet/lib/Helmet.js");
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _typography = __webpack_require__("./src/components/typography/index.js");
	
	var _recompose = __webpack_require__("./node_modules/recompose/cjs/Recompose.js");
	
	var _selectors = __webpack_require__("./src/selectors.js");
	
	var _NavBar = __webpack_require__("./src/components/NavBar.js");
	
	var _NavBar2 = _interopRequireDefault(_NavBar);
	
	var _Pad = __webpack_require__("./src/components/blocks/Pad.js");
	
	var _Pad2 = _interopRequireDefault(_Pad);
	
	var _Flex = __webpack_require__("./src/components/blocks/Flex.js");
	
	var _Flex2 = _interopRequireDefault(_Flex);
	
	var _utils = __webpack_require__("./src/utils.js");
	
	var _Responsive = __webpack_require__("./src/components/blocks/Responsive.js");
	
	var _Spacer = __webpack_require__("./src/components/blocks/Spacer.js");
	
	var _Spacer2 = _interopRequireDefault(_Spacer);
	
	var _Background = __webpack_require__("./src/components/blocks/Background.js");
	
	var _Background2 = _interopRequireDefault(_Background);
	
	var _Section = __webpack_require__("./src/components/blocks/Section.js");
	
	var _Section2 = _interopRequireDefault(_Section);
	
	var _Pipeline = __webpack_require__("./src/components/Pipeline.js");
	
	var _Pipeline2 = _interopRequireDefault(_Pipeline);
	
	var _FadeIn = __webpack_require__("./src/components/atoms/FadeIn.js");
	
	var _FadeIn2 = _interopRequireDefault(_FadeIn);
	
	var _Image = __webpack_require__("./src/components/Image.js");
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _ArrowLink = __webpack_require__("./src/components/ArrowLink.js");
	
	var _ArrowLink2 = _interopRequireDefault(_ArrowLink);
	
	var _Button = __webpack_require__("./src/components/atoms/Button.js");
	
	var _logofavcon2x = __webpack_require__("./assets/logofavcon@2x.png");
	
	var _logofavcon2x2 = _interopRequireDefault(_logofavcon2x);
	
	var _nestInstigator = __webpack_require__("./nest-instigator.jpeg");
	
	var _nestInstigator2 = _interopRequireDefault(_nestInstigator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var HeroImageWrapper = (0, _styledComponents2.default)(_Pad2.default)(_templateObject, function (props) {
	  return props.theme.media.tablet(_templateObject2);
	});
	
	var HFlexFlipperReverse = _Flex2.default.extend(_templateObject3, (0, _utils.r)("flex-direction", "row-reverse", "column"));
	
	var HeroText = _styledComponents2.default.div(_templateObject4, function (props) {
	  return props.theme.media.tablet(_templateObject5);
	});
	
	var TrialPage = function TrialPage(_ref) {
	  var background = _ref.background,
	      onColorChange = _ref.onColorChange,
	      data = _ref.data;
	
	  var content = (0, _selectors.getGraphNode)(data, "TrialPage");
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(
	      _Background2.default,
	      null,
	      _react2.default.createElement(
	        _reactHelmet2.default,
	        {
	          title: "Pipeline",
	          meta: [{ name: "Contraline", content: "Pipeline" }]
	        },
	        _react2.default.createElement("link", { rel: "icon", type: "image/png", href: _logofavcon2x2.default })
	      ),
	      _react2.default.createElement(_NavBar2.default, { color: "dark" }),
	      _react2.default.createElement(
	        _Section2.default,
	        { padLarge: true },
	        _react2.default.createElement(
	          _Pad2.default,
	          { v: 1 },
	          _react2.default.createElement(
	            _typography.P,
	            { style: { textAlign: "center", maxWidth: 650, margin: "0 auto" } },
	            content.pipelineIntro && content.pipelineIntro.pipelineIntro || "Contraline is developing a portfolio of male contraceptive products to give men real choices in family planning."
	          ),
	          _react2.default.createElement(_Spacer2.default, { span: 5 }),
	          _react2.default.createElement(
	            _FadeIn2.default,
	            { style: { transitionDelay: "1000ms" } },
	            _react2.default.createElement(_Pipeline2.default, { products: content.pipelineProducts && content.pipelineProducts.map(function (p) {
	                return {
	                  name: p.name,
	                  subtitle: p.subtitle,
	                  indications: [{ disease: p.indicationDisease, progress: p.indicationProgress, label: p.indicationLabel }]
	                };
	              }) })
	          ),
	          _react2.default.createElement(
	            _FadeIn2.default,
	            { style: { transitionDelay: "2000ms", textAlign: "center", marginTop: "8rem", color: "#000914", fontSize: "3rem" } },
	            _react2.default.createElement(
	              "div",
	              { style: { transform: "rotate(90deg)" } },
	              "\u203A"
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _Section2.default,
	        { v: 8 },
	        _react2.default.createElement(
	          _Flex.HFlexFlipper,
	          null,
	          _react2.default.createElement(
	            HeroText,
	            { style: { paddingLeft: 0, paddingRight: "6rem" } },
	            _react2.default.createElement(
	              _typography.H3,
	              null,
	              content.nestSectionTitle || "NES/T Hormonal Gel"
	            ),
	            _react2.default.createElement(
	              _typography.P,
	              null,
	              content.nestSectionBody && content.nestSectionBody.nestSectionBody || "Phase 2B clinical trials have been completed, demonstrating strong efficacy and tolerability. Contraline exclusively licensed NES/T from the Population Council to bring it to market."
	            ),
	            content.nestSectionBody2 && content.nestSectionBody2.nestSectionBody2 && _react2.default.createElement(
	              _typography.P,
	              null,
	              content.nestSectionBody2.nestSectionBody2
	            ),
	            _react2.default.createElement(
	              _Pad2.default,
	              { v: 0.75 },
	              _react2.default.createElement(
	                _ArrowLink2.default,
	                { color: "teal", to: "/nestorone" },
	                _react2.default.createElement(
	                  _typography.P,
	                  { color: "teal", style: { paddingBottom: 0 } },
	                  content.nestSectionLinkText || "Learn more about NES/T"
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            HeroImageWrapper,
	            { h: 1, mh: 0.5, style: { paddingRight: 0 } },
	            _react2.default.createElement("img", {
	              src: _nestInstigator2.default,
	              alt: "NES/T gel",
	              style: { width: "100%", height: "auto" }
	            })
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _Responsive.ShowMobile,
	        null,
	        _react2.default.createElement("div", { style: { height: 16 } })
	      ),
	      _react2.default.createElement(
	        _Section2.default,
	        { v: 8 },
	        _react2.default.createElement(
	          HFlexFlipperReverse,
	          null,
	          _react2.default.createElement(
	            HeroText,
	            null,
	            _react2.default.createElement(
	              _typography.H3,
	              null,
	              content.heroTitle || "ADAM Implant"
	            ),
	            _react2.default.createElement(
	              _typography.P,
	              null,
	              content.heroBody.heroBody
	            ),
	            _react2.default.createElement(_Spacer2.default, { span: 0.5 }),
	            _react2.default.createElement(
	              _typography.Description,
	              null,
	              content.heroLink && _react2.default.createElement(
	                _Pad2.default,
	                { v: 0.75 },
	                _react2.default.createElement(
	                  _ArrowLink2.default,
	                  { color: "teal", to: "/product" },
	                  _react2.default.createElement(
	                    _typography.P,
	                    { color: "teal", style: { paddingBottom: 0 } },
	                    content.heroLink
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _Responsive.ShowMobile,
	            null,
	            _react2.default.createElement(_Spacer2.default, { span: 3 })
	          ),
	          _react2.default.createElement(
	            HeroImageWrapper,
	            { h: 1, mh: 0.5, style: { paddingLeft: 0 } },
	            _react2.default.createElement(_Image2.default, {
	              full: true,
	              align: "center",
	              caption: "",
	              image: content.heroImage.responsiveResolution.src
	            })
	          )
	        )
	      ),
	      _react2.default.createElement(_Spacer2.default, { span: 4 })
	    )
	  );
	};
	
	var enhance = (0, _recompose.withState)("background", "onColorChange", "transparent");
	
	exports.default = enhance(TrialPage);
	var pageQuery = exports.pageQuery = "** extracted graphql fragment **";

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-trials-js-98949fe83933c82815cc.js